(ns manage.campaign-tags-page.constant)

(def default-settings
  {:display true
   :video true
   :preview true
   :dsp "all"
   :dimension "all"
   :display-tag-type "ins"})
